<template>
  <div>
    <div
      :id="id"
      :style="{
        width: '100%',
        height: `${height}px`,
        margin: '0 auto',
      }"
    ></div>
  </div>
</template>
<script>
import 'echarts/lib/component/legendScroll';
import 'echarts/lib/component/dataZoom';
import randomColor from 'randomcolor';

export default {
  props: {
    height: {
      type: Number,
      default: 400,
    },
    // echarts图的id
    id: {
      type: String,
    },
    // 如果是单折线/柱状图，data:{x:[],y:[]}两个数组分别放坐标轴和图的数据,
    // 如果是堆叠折线/柱状图，data.y为y:[{name:'',data:[]}, {name:'',data:[]}]
    data: {
      type: Object,
    },
    // 图的类型
    type: {
      type: String,
      default: 'line',
    },
    // x轴的类型
    xType: {
      type: String,
      default: 'category',
    },
    // y轴的类型
    yType: {
      type: String,
      default: 'value',
    },
    // 是否块堆叠
    iscolPlie: {
      type: Boolean,
      default: false,
    },
    // 是否线堆叠
    islinePlie: {
      type: Boolean,
      default: false,
    },
    // multiple-x-axis
    isMultipleX: {
      type: Boolean,
      default: false,
    },
    // 是否显示数据在图上
    showData: {
      type: Boolean,
      default: false,
    },
    // 是否显示x轴
    xShow: {
      type: Boolean,
      default: true,
    },
    // 是否显示y轴
    yShow: {
      type: Boolean,
      default: true,
    },
    isMountedRender: {
      type: Boolean,
      default: false,
    },
    isShowAreaStyle: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    data: {
      handler() {
        this.drawEchart();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.isMountedRender) {
      this.drawEchart();
    }
  },
  data() {
    return {};
  },
  methods: {
    // 初始化echarts
    echartsInit() {
      // 柱形图
      // 因为初始化echarts 的时候，需要指定的容器 id='main'
      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: null,
          borderWidth: 0,
          borderRadius: 0,
          // axisPointer: {
          //   type: 'line',
          //   axis: 'x',
          //   label: {
          //     show: true,
          //     color: 'rgb(255, 151, 36)',
          //     backgroundColor: 'rgba(255, 255, 255, .8)',
          //     shadowBlur: 0,
          //     margin: 0,
          //   },
          //   lineStyle: {
          //     type: 'dashed',
          //     color: '#b6b5b7',
          //   },
          // },
          textStyle: {
            color: '#333',
            align: 'left',
            fontSize: 14,
          },
          enterable: true,
          formatter(params) {
            const html = params.map((item) => `
            <div style="display: flex;min-width: 120px;justify-content: space-between">
              <div>
                <p
                  style="
                  display: inline-block;
                  border-radius: 10px;
                  height: 10px;
                  width: 10px;
                  background-color: ${item.color};"
                ></p>
                ${item.seriesType === 'line' ? `${item.seriesName}` : `<span style="margin-right: 15px;">${params[0].axisValueLabel.replace(/\n/g, '')}</span>`}
              </div>
              <p><strong>${item.value}</strong></p>
            </div>`).join('');

            const res = `
              <div style="
                padding: 10px;
                box-shadow: 0 0 3px 3px rgba(0,0,0, .09);
                background: #fff;
                border-radius: 5px;max-height: 260px;overflow: auto;"
              >
                ${params[0].seriesType === 'line' ? `<div>${params[0].axisValueLabel.replace(/\n/g, '')}</div>` : ''}
                ${html}
              </div>`;
            return res;
          },
          position(point, params, dom, rect, size) {
            // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
            const x = point[0]; //
            const y = point[1];
            const boxWidth = size.contentSize[0];
            const boxHeight = size.contentSize[1];
            let posX = 0; // x坐标位置
            let posY = 0; // y坐标位置

            if (x < boxWidth) {
              // 左边放不开
              posX = 5;
            } else {
              // 左边放的下
              posX = x - boxWidth;
            }

            if (y < boxHeight) {
              // 上边放不开
              posY = 0;
            } else {
              // 上边放得下
              posY = y - boxHeight;
            }

            return [posX, posY];
          },
        },
        // toolbox: {
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: 'none',
        //     },
        //     restore: {},
        //     saveAsImage: {},
        //   },
        // },
        grid: { // 显示数据的图表位于当前canvas的坐标轴
          x: 0,
          y: 10,
          x2: 20,
          y2: 60,
          borderWidth: 1,
          containLabel: true,
        },
        xAxis: {
          type: this.xType,
          data: this.data.x,
          boundaryGap: false,
          show: this.xShow,
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#666666',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            // interval: 0, // 坐标刻度之间的显示间隔，默认就可以了（默认是不重叠）
            // rotate: 38, // 调整数值改变倾斜的幅度（范围-90到90）
            // textStyle: {
            color: '#666666', // 坐标值得具体的颜色
            // },
          },
        },
        yAxis: {
          type: this.yType,
          data: this.data.x,
          show: this.yShow,
          // 设置轴线的属性
          axisLine: {
            show: true,
            lineStyle: {
              color: '#3673e8',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            interval: 0, // 坐标刻度之间的显示间隔，默认就可以了（默认是不重叠）
            // rotate: 20, // 调整数值改变倾斜的幅度（范围-90到90）
            lineHeight: 15,
            verticalAlign: 'middle',
            // textStyle: {
            color: this.yType === 'value' ? '#b6b5b7' : '#000', // 坐标值得具体的颜色
            // },
          },
        },
        series: [
          {
            data: this.data.y,
            type: this.type,
            smooth: true,
            label: {
              show: this.showData,
              // position: 'right',
            },
            itemStyle: {
              color: '#3673e8',
            },
            barWidth: 20,
          },
        ],
        // tooltip: {
        //   trigger: 'axis',
        //   axisPointer: {
        //     type: 'cross',
        //     label: {
        //       backgroundColor: '#6a7985',
        //     },
        //   },
        // },
      };
      if (this.iscolPlie) {
        const newseries = [];
        this.data.y.forEach((item) => {
          newseries.push({
            name: item.name,
            type: 'bar',
            stack: 'total',
            label: {
              show: false,
            },
            emphasis: {
              focus: 'series',
            },
            data: item.data,
          });
        });
        option.legend = {};
        option.series = newseries;
      } else if (this.islinePlie) {
        const newseries = [];
        const colorList = randomColor({
          luminosity: 'light',
          count: this.data.y.length,
          format: 'rgba',
          alpha: 1,
        });
        this.data.y.forEach((item, index) => {
          const newItem = {
            name: item.name,
            type: 'line',
            smooth: true,
            label: {
              show: false,
            },
            emphasis: {
              focus: 'series',
            },
            lineStyle: {
              // width: 4,
              type: 'solid', // 'dotted'虚线 'solid'实线
            },
            itemStyle: {
              color: colorList[index],
            },
            data: item.data,
          };

          // 是否展示曲线覆盖面积
          if (this.isShowAreaStyle) {
            newItem.areaStyle = {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: colorList[index].replace(/,(\d|\s|\.)+\)/g, () => ',0.7)'),
              }, {
                offset: 1,
                color: 'rgb(251, 252, 255)',
              }]),
            };
          }

          newseries.push(newItem);
        });
        const isMoreDate = this.data.x.length > 15;
        // 超过半个月使用略缩图
        option.legend = {
          bottom: isMoreDate ? 40 : 0,
          type: 'scroll',
          height: 100,
          itemWidth: 10,
          itemHeight: 10,
          formatter: (name) => (name.length > 10
            ? name.replace(new RegExp(`^(.{${name.length / 2}})`, 'g'), '$1\n') : name),
          // name.split('').map((item, index) =>
          // (!((index + 1) % 10) ? `${item}\n` : item)).join(''),
        };
        // 底部Zoom
        if (isMoreDate) {
          option.dataZoom = [
            {
              type: 'slider', // 滑动条
              show: true, // 开启
              xAxisIndex: [0],
              bottom: '0',
              left: '0', // 滑动条位置
              right: '0.5%',
              start: 0, // 初始化时，滑动条宽度开始标度
              end: (7 / this.data.x.length) * 100, // 初始化时，滑动条宽度结束标度<br>                   },
            },
          ];
        }
        option.grid = {
          x: 0,
          y: 10,
          x2: 35,
          y2: isMoreDate ? 80 : 40,
          borderWidth: 2,
          containLabel: true,
        };
        option.series = newseries;
      } else if (this.isMultipleX) {
        const colorList = ['#5793f3', '#d14a61', '#675bba'];
        // option.tooltip = {
        //   trigger: 'none',
        //   axisPointer: {
        //     type: 'cross',
        //   },
        // };
        const isMoreDate = this.data.x[0].data.length > 15;
        // 底部Zoom
        if (isMoreDate) {
          option.dataZoom = [
            {
              type: 'slider', // 滑动条
              show: true, // 开启
              xAxisIndex: [0, 1],
              bottom: '0',
              left: '0', // 滑动条位置
              right: '0.5%',
              start: 0, // 初始化时，滑动条宽度开始标度
              end: (15 / this.data.x[0].data.length) * 100,
            },
          ];
        }
        option.legend = {
          data: this.data.legend,
        };
        option.yAxis = [
          {
            type: 'value',
          },
        ];
        option.grid = {
          x: 0,
          y: 30,
          x2: 10,
          y2: isMoreDate ? 40 : 0,
          borderWidth: 2,
          containLabel: true,
        };
        option.series = [
          {
            name: this.data.y[0].name,
            type: 'line',
            xAxisIndex: 1,
            smooth: true,
            data: this.data.y[0].data,
            itemStyle: {
              color: colorList[0],
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: colorList[0].replace(/,(\d|\s|\.)+\)/g, () => ',0.7)'),
              }, {
                offset: 1,
                color: 'rgb(251, 252, 255)',
              }]),
            },
          },
          {
            name: this.data.y[1].name,
            type: 'line',
            smooth: true,
            data: this.data.y[1].data,
            itemStyle: {
              color: colorList[1],
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: colorList[1].replace(/,(\d|\s|\.)+\)/g, () => ',0.7)'),
              }, {
                offset: 1,
                color: 'rgb(251, 252, 255)',
              }]),
            },
          },
        ];
        option.xAxis = [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: '#333333',
              },
            },
            axisPointer: {
              label: {
                formatter(params) {
                  return `${params.value
                  }${params.seriesData.length ? `：${params.seriesData[0].data}` : ''}`;
                },
              },
            },
            data: this.data.x[0].data,
          },
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: '#333333',
              },
            },
            axisPointer: {
              label: {
                formatter(params) {
                  return `${params.value
                  }${params.seriesData.length ? `：${params.seriesData[0].data}` : ''}`;
                },
              },
            },
            data: this.data.x[1].data,
          },
        ];
      } else {
        if (this.data.y.length > 10) {
          // 底部Zoom
          option.dataZoom = [
            {
              type: 'slider', // 滑动条
              show: true, // 开启
              yAxisIndex: [0],
              left: '96%', // 滑动条位置
              start: (1 - 8 / this.data.y.length) * 100, // 初始化时，滑动条宽度开始标度
              end: 100, // 初始化时，滑动条宽度结束标度<br>                   },
            },
          ];
        }
        option.grid = { // 显示数据的图表位于当前canvas的坐标轴
          x: 0,
          y: 0,
          x2: 100,
          y2: 0,
          borderWidth: 1,
          containLabel: true,
        };
      }
      const myEchart = this.$echarts.init(document.getElementById(`${this.id}`), 'light');
      myEchart.clear();
      myEchart.setOption(option);
      // 页面大小发生改变时Echarts也跟着发生改变
      window.addEventListener('resize', () => {
        if (myEchart.resize) {
          myEchart.resize();
        }
      });
    },
    echartsInitPie() {
      const datas = this.data.data;
      const option = {
        name: this.data.name,
        tooltip: {
          trigger: 'item',
        },
        legend: {
          // top: '5%',
          bottom: '0%',
          icon: 'circle',
          formatter(name) {
            let total = 0;
            let tarValue;
            for (let i = 0; i < datas.length; i++) {
              total += datas[i].value;
              if (name === datas[i].name) {
                tarValue = datas[i].value;
              }
            }
            const p = Math.round((tarValue / total) * 100);
            return `${name} ${p}%`;
          },
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['50%', '60%'],
            avoidLabelOverlap: false,
            // tooltip: {
            //   formatter(p) {
            //     return `时间：${p.name}<br/>数量：${p.value}条`;
            //   },
            //   extraCssText: 'text-align:left',
            // },
            // label: {
            //   show: false,
            //   position: 'center',
            // },
            emphasis: {
              label: {
                show: false,
                fontSize: '16',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: [...this.data.data, {
              tooltip: {
                show: false,
              },
              label: {
                normal: {
                  formatter: this.data.name,
                  fontSize: '18',
                  position: 'center',
                  color: '#333333',
                  // 让文字居中
                  show: true,
                },
              },
            }],
          },
        ],
      };
      const myEchart = this.$echarts.init(document.getElementById(`${this.id}`), 'light');
      myEchart.clear();
      myEchart.setOption(option);
      // 页面大小发生改变时Echarts也跟着发生改变
      window.addEventListener('resize', () => {
        if (myEchart.resize) {
          myEchart.resize();
        }
      });
    },
    echartsInitMore() {
      const isMoreDate = this.data.xAxis.length > 15;
      const option = {
        grid: { // 显示数据的图表位于当前canvas的坐标轴
          x: 0,
          y: 10,
          x2: 20,
          y2: isMoreDate ? 70 : 60,
          borderWidth: 1,
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: null,
          borderWidth: 0,
          borderRadius: 0,
          axisPointer: {
            type: 'shadow',
            axis: 'x',
            shadowStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(0, 0, 0, .1)', // 0% 处的颜色
                }],
                global: false, // 缺省为 false
              },
            },
            label: {
              show: true,
              color: 'rgb(255, 151, 36)',
              backgroundColor: 'rgba(255, 255, 255, .8)',
              shadowBlur: 0,
              margin: 0,
            },
            lineStyle: {
              type: 'dashed',
              color: '#b6b5b7',
            },
          },
          textStyle: {
            color: '#333',
            align: 'left',
            fontSize: 14,
          },
          enterable: true,
          formatter(params) {
            const html = params.map((item) => `
            <div style="display: flex;min-width: 120px;justify-content: space-between">
              <div>
                <p
                  style="
                  display: inline-block;
                  border-radius: 10px;
                  height: 10px;
                  width: 10px;
                  background-color: ${item.color};"
                ></p>
                ${item.seriesName}
              </div>
              <p><strong>${item.value}</strong></p>
            </div>`).join('');

            const res = `
              <div style="
                padding: 10px;
                box-shadow: 0 0 3px 3px rgba(0,0,0, .09);
                background: #fff;
                border-radius: 5px;max-height: 260px;overflow: auto;"
              >
                <div style="margin-bottom: 5px">${params[0].axisValueLabel}</div>
                ${html}
              </div>`;
            return res;
          },
          position(point, params, dom, rect, size) {
            // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
            const x = point[0]; //
            const y = point[1];
            const boxWidth = size.contentSize[0];
            const boxHeight = size.contentSize[1];
            let posX = 0; // x坐标位置
            let posY = 0; // y坐标位置

            if (x < boxWidth) {
              // 左边放不开
              posX = 5;
            } else {
              // 左边放的下
              posX = x - boxWidth;
            }

            if (y < boxHeight) {
              // 上边放不开
              posY = 0;
            } else {
              // 上边放得下
              posY = y - boxHeight;
            }

            return [posX, posY];
          },
        },
        legend: {
          // top: '5%',
          bottom: isMoreDate ? '11%' : '5%',
          icon: 'circle',
          tooltip: {
            show: true,
            formatter: (params) => {
              const {
                xAxis,
                series,
              } = this.data;
              const data = series.filter(({ name }) => name === params.name)[0]?.data;
              const html = data.map((item, index) => `
            <div style="display: flex;min-width: 120px;justify-content: space-between">
              <div>
                ${xAxis[index]}
              </div>
              <p><strong>${item}</strong></p>
            </div>`).join('');
              const res = `
                <div style="
                  padding: 10px;
                  box-shadow: 0 0 3px 3px rgba(0,0,0, .09);
                  background: #fff;
                  border-radius: 5px;max-height: 260px;overflow: auto;"
                >
                  <div style="margin-bottom: 5px">${params.name}</div>
                  ${html}
                </div>`;
              return res;
            },
          },
        },
        xAxis: {
          type: 'category',
          data: this.data.xAxis,
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLine: {
            show: true,
          },
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: this.data.series,
      };
      // 底部Zoom
      if (isMoreDate) {
        option.dataZoom = [
          {
            type: 'slider', // 滑动条
            show: true, // 开启
            xAxisIndex: [0],
            bottom: '0',
            left: '0', // 滑动条位置
            right: '0.5%',
            start: 0, // 初始化时，滑动条宽度开始标度
            end: (15 / this.data.xAxis.length) * 100,
          },
        ];
      }
      const dom = document.getElementById(`${this.id}`);
      // dom.innerHTML = null;
      const myEchart = this.$echarts.init(dom, 'light');
      myEchart.clear();
      myEchart.setOption(option);

      // 页面大小发生改变时Echarts也跟着发生改变
      window.addEventListener('resize', () => {
        if (myEchart.resize) {
          myEchart.resize();
        }
      });
    },
    drawEchart() {
      // 环形图走这
      if (this.type === 'pie') {
        this.echartsInitPie();
        return;
      }
      // 多个柱状图走这
      if (this.type === 'more') {
        this.echartsInitMore();
        return;
      }
      // 单柱状图，折线图走这
      this.echartsInit();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
